<div class="container-ticket-combo">
  <am-expandable-group [selectedExpandable]="ticketSelected" name="ticket">
    <h6 title>
      @switch (ticket.ticket) {
        @case ('BASICO') { <span>Un parque por día</span> }
        @case ('BASICO_PLUS') {
          <span>Un parque por día +<br />Water park and sport</span>
        }
        @case ('PARK_HOPPER') { <span>Opción <i>Park Hopper</i></span> }
        @case ('PARK_HOPPER_PLUS') { <span>Opción <i>Park Hopper Plus</i></span> }
      }
    </h6>
    <span static>
      @switch (ticket.ticket) {
        @case ('BASICO') {
          <span>Con esta entrada soló podrás recorrer un parque temático por día.</span>
        }
        @case ('BASICO_PLUS') {
          <span>Por cada pase, sumás una visita a los parques acuáticos y campos de golf</span>
        }
        @case ('PARK_HOPPER') { <span>¡Recorré más de un parque por día!</span> }
        @case ('PARK_HOPPER_PLUS') {
          <span>Incluye parques acuáticos y atracciones de golf.</span>
        }
      }
    </span>
    <span body>
      @switch (ticket.ticket) {
        @case ('BASICO') {
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span>
              Recorré <strong>un parque</strong> de los 4 parques tématicos por día
            </span>
          </div>
        }
        @case ('BASICO_PLUS') {
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span>
              <strong>Incluye parques acuáticos:</strong>
              <div class="names">
                <span> Disney's Blizzard Beach, Disney's Typhoon Lagoon. </span>
              </div>
            </span>
          </div>
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span>
              <strong>Incluye atracciones de golf:</strong>
              <div class="names">
                <span>
                  Disney's Oak Trail Golf Course, ESPN Wide World of Sports Complex,
                  Disney's Fantasia Gardens Miniature Golf Course, Disney's Winter
                  Summerland Miniature Golf Course.
                </span>
              </div>
            </span>
          </div>
        }
        @case ('PARK_HOPPER') {
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span
              >visitá <strong>todos los parques</strong> que quieras, como quieras.
            </span>
          </div>
        }
        @case ('PARK_HOPPER_PLUS') {
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span
              >visitá <strong>todos los parques</strong> que quieras, como quieras.
            </span>
          </div>
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span>
              <strong>Incluye parques acuáticos:</strong>
              <div class="names">
                <span> Disney's Blizzard Beach, Disney's Typhoon Lagoon. </span>
              </div>
            </span>
          </div>
          <div class="item-ticket">
            <mb-icon icon="check-simple"></mb-icon>
            <span>
              <strong>Incluye atracciones de golf:</strong>
              <div class="names">
                <span>
                  Disney's Oak Trail Golf Course, ESPN Wide World of Sports Complex,
                  Disney's Fantasia Gardens Miniature Golf Course, Disney's Winter
                  Summerland Miniature Golf Course.
                </span>
              </div>
            </span>
          </div>
        }
      }
    </span>
    <div class="price-total" [ngClass]="{ 'selected-top': ticketSelected }">
      <span>Precio total</span>

      <div class="cost">
        {{ currencyLabel }}
        {{ ticket.total_amount | Currency }}
      </div>

      <span
        >Precio por día por adulto:<br />
        {{ currencyLabel }}
        {{ ticket.amount_per_night_per_room | Currency }}
      </span>

      @if (!ticketSelected) {
        <button
          [disabled]="!ticketDate || disabled"
          class="btn add-ticket"
          mb-button
          variant="outline"
          color="secondary"
          (click)="selectedTicket()"
        >
          {{ ticketDate ? 'Agregar' : 'Seleccione una fecha' }}
        </button>
      } @else {
        <button
          class="btn"
          mb-button
          variant="floating"
          color="secondary"
          [disabled]="disabled"
          (click)="emptyTicket()"
        >
          Eliminar
        </button>
      }
    </div>
  </am-expandable-group>
</div>
